// TODO: Horizontal scroll, columns widen to fit content
export const baseTableSx = {
    '.bold-red': {
        fontWeight: 'bold',
        color: 'red',
    },
    '& .MuiDataGrid-cell': {
        fontSize: '14px',
        padding: '14px 16px',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 600,
        fontSize: '12px',
        textTransform: 'uppercase',
    },
    '& .MuiDataGrid-row.MuiDataGrid-row--deleted': {
        backgroundColor: 'rgba(255, 0, 0, 0.1)',
        '&:hover': {
            backgroundColor: 'rgba(255, 0, 0, 0.2)',
        },
    },
};

export const baseToolbarProps = {
    exportable: true,
    columns: true,
    exportOptions: {
        buttonSx: {
            color: 'secondary.extraLight',
            border: 'none',
            minWidth: 0,
        },
    },
    toolbarSx: {
        padding: (theme) => theme.spacing(2, 3),
    },
};
